<script setup>
import { ref, watch, onMounted } from 'vue';
import Question from "../components/Question.vue";
import RelateList from "../components/RelateList.vue";
import FeedbackEntranceSimple from "../components/FeedbackEntranceSimple.vue";
import { useRoute } from 'vue-router';
const question = ref({});
const router = useRoute();

onMounted(() => {
  question.value = router.query;
});

watch(() => router.query, (newValue) => {
  question.value = newValue;
});
</script>

<template>
  <div class="main">
    <Question :id="question.id" :content="question.content" :answer="question.answer"/>
    <RelateList :feedback-id="question.id" :category-id="question.categoryId" :module-id="question.moduleId"/>
    <FeedbackEntranceSimple/>
  </div>
</template>

<style lang="scss" scoped>
@import '~/entries/index/index.scss';
.main {
  background: rgba(245, 248, 253, 1);
  min-height: 100vh;
  padding-top: 24*$px;
  padding-bottom: 141*$px;
}
</style>
